import { GlobalSearchTab, Search } from "@/models/search/Search";

export const getTabsName = (tab: GlobalSearchTab) => {
  switch (tab) {
    case GlobalSearchTab.All:
      return "Alle";
    case GlobalSearchTab.Chat:
      return "Chat";
    case GlobalSearchTab.Workspace:
      return "Workspace";
    case GlobalSearchTab.Legislation:
      return "Kilder";
    case GlobalSearchTab.WorkspaceDocuments:
      return "Workspace dokumenter";
    case GlobalSearchTab.FavoriteSearches:
      return "Favoritter";
    case GlobalSearchTab.Sources:
      return "Kildesøgning";
    default:
      return "N/A";
  }
};

/**
 * The same search without the text the user typed — the search term and the
 * search tags — keeping the tab and the filters it was made with.
 */
export const withClearedSearchText = (search: Search): Search => ({
  ...search,
  searchTerm: "",
  searchTags: [],
});
